import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import AppNavbar from "./AppNavbar";

const API_BASE = 'https://hospital.rozeetechnist.com/hospital-api';

const ContributionUpdate = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [form, setForm] = useState({
        title: '',
        amount: '',
        description: '',
        status: 'active'
    });
    const [loading, setLoading] = useState(false);
    const [fetching, setFetching] = useState(true);

    useEffect(() => {
        if (!localStorage.getItem('login')) {
            navigate('/login');
            return;
        }
        if (!id) {
            navigate('/contribution-list');
            return;
        }
        fetch(`${API_BASE}/getContribution.php`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id })
        })
            .then((res) => res.json())
            .then((result) => {
                setFetching(false);
                if (result.status && result.data) {
                    const d = result.data;
                    setForm({
                        title: d.title || '',
                        amount: d.amount != null ? d.amount : '',
                        description: d.description || '',
                        status: d.status || 'active'
                    });
                } else {
                    toast.error(result.message || 'Contribution not found');
                    navigate('/contribution-list');
                }
            })
            .catch((err) => {
                console.error(err);
                setFetching(false);
                toast.error('Failed to load');
                navigate('/contribution-list');
            });
    }, [id, navigate]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const getLoggedUserId = () => {
        try {
            const loginData = localStorage.getItem('login');
            if (loginData) return JSON.parse(loginData).id;
        } catch (_) {
            // ignore parse error
        }
        return null;
    };

    const handleSubmit = () => {
        if (!form.title.trim()) {
            toast.error('Please enter Title');
            return;
        }
        const amountVal = form.amount === '' || isNaN(parseFloat(form.amount)) ? '' : parseFloat(form.amount);
        if (amountVal !== '' && amountVal < 0) {
            toast.error('Amount cannot be negative');
            return;
        }
        const userId = getLoggedUserId();
        if (!userId) {
            toast.error('Please login again');
            return;
        }

        const payload = {
            id,
            title: form.title.trim(),
            description: form.description.trim(),
            status: form.status,
            updated_by: userId
        };
        if (amountVal !== '') payload.amount = amountVal;

        setLoading(true);
        fetch(`${API_BASE}/updateContribution.php`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        })
            .then((res) => res.json())
            .then((resp) => {
                setLoading(false);
                if (resp.status) {
                    toast.success(resp.message);
                    navigate('/contribution-list');
                } else {
                    toast.error(resp.message || 'Failed to update');
                }
            })
            .catch((err) => {
                console.error(err);
                setLoading(false);
                toast.error('An error occurred');
            });
    };

    if (fetching) {
        return (
            <div>
                <AppNavbar />
                <div className="container"><p>Loading...</p></div>
            </div>
        );
    }

    return (
        <div>
            <AppNavbar />
            <div className="container">
                <div className="row top-page-bar">
                    <div className="col-9">
                        <div className="main-title">
                            <h1>Edit Contribution</h1>
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="search-area">
                            <div className="buttons">
                                <Link className="btn btn-secondary" to="/contribution-list">Back</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row g-3">
                    <div className="col-md-6">
                        <label className="form-label">Title <span className="text-danger">*</span></label>
                        <input
                            className="form-control"
                            name="title"
                            value={form.title}
                            onChange={handleChange}
                            placeholder="Enter title"
                            required
                        />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Amount (optional)</label>
                        <input
                            type="number"
                            step="0.01"
                            min="0"
                            className="form-control"
                            name="amount"
                            value={form.amount}
                            onChange={handleChange}
                            placeholder="Enter amount"
                        />
                        <small className="text-muted">Changing amount will create a new version; current one will be marked inactive.</small>
                    </div>
                    <div className="col-12">
                        <label className="form-label">Description</label>
                        <textarea
                            className="form-control"
                            name="description"
                            value={form.description}
                            onChange={handleChange}
                            placeholder="Enter description"
                            rows={3}
                        />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Status</label>
                        <select
                            className="form-control"
                            name="status"
                            value={form.status}
                            onChange={handleChange}
                        >
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                        </select>
                    </div>
                    <div className="col-12">
                        <button
                            className="btn btn-primary btn-lg"
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            {loading ? 'Saving...' : 'Update'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContributionUpdate;
